import { render } from "./SelectDoctor.vue?vue&type=template&id=e06a852a&scoped=true"
import script from "./SelectDoctor.vue?vue&type=script&lang=js"
export * from "./SelectDoctor.vue?vue&type=script&lang=js"

import "./SelectDoctor.vue?vue&type=style&index=0&id=e06a852a&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e06a852a"]])

export default __exports__